import { useState, useCallback, useEffect } from 'react'
import { validateTaxNumber } from '@buy/services'
import { useDispatch, useSelector } from 'react-redux'
import { getBuyFormState } from '@buy/state/selectors'
import { buyFormActions } from '@buy/state/buy-form/actions'

export const useTaxNumberValidation = (setIsDisabled: (value: boolean) => void) => {
    const [isValidating, setIsValidating] = useState(false)
    const dispatch = useDispatch()
    const { isTaxNumberValid } = useSelector(getBuyFormState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => setIsDisabled(isValidating), [isValidating])

    const validate = useCallback(
        async (country: string, taxNumber: string, federalTaxType?: string) => {
            setIsValidating(true)

            try {
                await validateTaxNumber(country, taxNumber, federalTaxType)
                dispatch(buyFormActions.setIsTaxNumberValid(true))
            } catch (e) {
                dispatch(buyFormActions.setIsTaxNumberValid(false))
            } finally {
                setIsValidating(false)
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [setIsValidating, setIsDisabled]
    )

    return {
        validate,
        isValid: isTaxNumberValid,
        isValidating,
    }
}
